import { cmsUrl } from "@/utils/helper";
import Image from "next/image";
import { useState } from "react";
import CardNumber from "./Common/CardNumber";

const CASE_STUDY_ACCORDION_DATA = [
  {
    id: 1,
    title: "Database Creation",
    description:
      "To consider current and future features, the technical architect designed a new database structure and created it in MongoDB.",
  },
  {
    id: 2,
    title: "API and Backend Development",
    description:
      "To clear the API and backend mess, the entire new backend with the proper logic and scalability in mind using Node and ExpressJS.",
  },
  {
    id: 3,
    title: "Mobile Application",
    description:
      "The&nbsp;<a href='https://ultroneous.com/mobile-application-development-services'>mobile app development</a>&nbsp;is done in Kotlin for Android and Swift for iOS. The mobile application with all agreed features works with NFC technology integration.",
  },
  {
    id: 4,
    title: "PWA",
    description: `The&nbsp;<a href={${cmsUrl}/what-is-progressive-web-app-pwa/}>Progressive web app</a>&nbsp; was created for the one-tap feature using advanced ReactJS and Redux to manage front end, states and user data access for a faster network connection.`,
  },
];

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const onItemClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <>
      <div className="flex justify-start p-4 md:py-16 md:px-10 xl:px-16">
        <div className="w-1/2 md:pl-4 xl:pl-16">
          <CardNumber
            description="Deliverables we built"
            number="03"
            title="SERVICES GIVEN"
          />
        </div>
      </div>
      <div className="flex flex-col xl:flex-row justify-start md:justify-end pt-8 px-4 pb-16 md:pt-0 md:pr-16 md:pb-0 md:pl-10 xl:pb-16 text-justify h-[68vh] md:h-[44vh] xl:h-[55vh]">
        <div className="w-full xl:w-8/12">
          <div>
            {CASE_STUDY_ACCORDION_DATA.map((value, index) => (
              <div key={index}>
                <div className="border border-solid border-x-0 border-t-0 border-gray-300 my-4">
                  <div
                    className="text-left py-4 md:px-5 flex justify-between items-center cursor-pointer"
                    onClick={() => onItemClick(index)}
                  >
                    <h4 className="font-normal text-base md:text-lg flex items-center text-black w-11/12 px-5 md:px-0">
                      <span className="flex mr-4 w-6 h-6 md:w-auto md:h-auto">
                        {index === activeIndex ? (
                          <Image
                            src="/assets/case-study/social-networking/decrement.webp"
                            width={32}
                            height={32}
                            alt="minus"
                          />
                        ) : (
                          <Image
                            src="/assets/case-study/social-networking/increment.webp"
                            width={32}
                            height={32}
                            alt="plus"
                          />
                        )}
                      </span>
                      <span className="mr-4">{value.title}</span>
                    </h4>
                  </div>
                  <div
                    className={`p-4 text- text-base text-justify pt-0 pl-16 pr-5 pb-4 text-black ${
                      index === activeIndex ? "block" : "hidden"
                    }`}
                  >
                    <span
                      dangerouslySetInnerHTML={{ __html: value.description }}
                      className="[&>a]:text-blue-600 [&>a]:hover:text-primary-yellow"
                    ></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Accordion;
